export default __webpack_public_path__ + "static/774-43ef054bfd0fa63f5eda460931ceab0e.gif";